import WebpImage from '@r1-frontend/ui-react/components/WebpImage';

import { PromoParagraph1, PromoTextWithStyleHeading2 } from '~/src/features/internetV2/components/typography';

import * as ST from './styled';

export interface IWideSmallBannerProps {
    image: string,
    imageWebp: string,
    title: React.ReactNode,
    description: React.ReactNode,
    key?: string,
}

const WideSmallBanner = ({
    image,
    imageWebp,

    title,
    description,

    key,
}: IWideSmallBannerProps): JSX.Element => {
    return (
        <ST.RounderContainerWithBackground
            key={key}
            $desktop={32}
            $mobile={24}
        >
            <ST.ListContainerWithAlign
                $size={8}
                $wrap={'nowrap'}
            >
                <ST.TextWrapperWithMargin>
                    <PromoTextWithStyleHeading2>{title}</PromoTextWithStyleHeading2>
                    <PromoParagraph1>{description}</PromoParagraph1>
                </ST.TextWrapperWithMargin>
                <WebpImage urlWebp={imageWebp}>
                    <ST.Image src={image} />
                </WebpImage>
            </ST.ListContainerWithAlign>
        </ST.RounderContainerWithBackground>
    );
};

export default WideSmallBanner;
